export const ACCOUNTS_API = '/atlas/api/v1/accounts'
export const CORRESPONDENTS_API = `/correspondent-provider/api/v2/correspondents`
export const BRAGGART_API = '/braggart/api/v1/transactions'
export const MARGINS_API = '/margin-provider/api/v1/margins'
